import * as React from "react";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import * as types from "../../constants/actionTypes";
import { Link, Redirect } from 'react-router-dom';
import { numIntoWords } from "../../helpers/formatting";
import Spinner from "../common/spinner";
import FamilyMemberProxyUser from "./FamilyMemberProxyUser";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";
import SectionLoadingError from "../common/SectionLoadingError";
import FamilyWithNoMember from "./FamilyWithNoMember";
import ProxySuggestions from "./ProxySuggestions";

class FamilyMembers extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            userHeading: null,
            usersCount: 0,
        }

    }

    componentDidMount() {
        const { hasMyChartLogin, showFamilyMembersScreen, proxySource, userId,useOnboardingLayout, isAdult, hasProxySuggestions, getRequestProxySuggestion } = this.props;
        logUI(`MBHWeb.UI.FamilyMembers.ComponentDidMount${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        getRequestProxySuggestion();
        let skipPage = !hasMyChartLogin || !showFamilyMembersScreen || !isAdult;

        if (skipPage) {

            let skipReason = this.getSkipReason();
            skipReason = skipReason && skipReason === "" ? "" : ".".concat(skipReason);
            let logActivityCode = `MBHWeb.UI.FamilyMembers.Skipped${skipReason}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`;
            logUI(logActivityCode, new Date(), Tools.getURLPath());
            this.goToNextPage();
        }
        else
            this.props.getRequestProxyPendingUsers(proxySource, userId);
    }

    componentDidUpdate(prevProps) {
        // Comparing prevProps to updatedProps
        const { hasProxySuggestions, newProxySuggestionList, useOnboardingLayout } = this.props;
        if (newProxySuggestionList !== prevProps.newProxySuggestionList) {
            let skipPage = hasProxySuggestions;
            if (skipPage) {
                let skipReason = "HasProxySuggestions";
                let logActivityCode = `MBHWeb.UI.FamilyMembers.ComponentDidUpdate.Skipped${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`;
                logUI(logActivityCode, new Date(), Tools.getURLPath(), { skipReason: skipReason });
            }

        }
    }

    getSkipReason() {
        const { hasMyChartLogin, showFamilyMembersScreen, isAdult } = this.props;
        if (!isAdult)
            return "isMinor";
        else if (!showFamilyMembersScreen)
            return "FamilyMembersPreferenceIsFalse";
        else if (!hasMyChartLogin)
            return "NoMyChart";
        else
            return "";

    }

    getNextLocation() {
        let { showNotificationsScreen } = this.props;
        return showNotificationsScreen ? '/onboarding/managenotifications' : '/';

    }

    goToNextPage() {
        try {
            //go to next screen in the workflow i.e. NotificationPreferences screen            
            this.props.history.push(this.getNextLocation());
        }
        catch (e) {
            window.location.href = "/";
        }

    }

    //Update Preference, and set it to 'false', when any of the buttons/links ('Skip', or 'Add Family member') is clicked
    UpdatePreference(linkName, hasFamilyMembers) {
        const { useOnboardingLayout } = this.props;
        if (hasFamilyMembers) {
            logUI(`MBHWeb.UI.FamilyMembers.UpdatePreference.${linkName}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath())
        }
        else {
            logUI(`MBHWeb.UI.FamilyWithNoMember.UpdatePreference.${linkName}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath())
        }
        this.props.updateFamilyMembersScreenPreference && this.props.updateFamilyMembersScreenPreference();
    }


    render() {

        const { proxyUsersInfo, myChartUsers, hasProxySuggestions, EnableProxySuggestion } = this.props;

        let pharmacyUsers = [];
        let pharmacyPendingUsers = [];
        let myChartPendingUsers = [];


        if (proxyUsersInfo && proxyUsersInfo.response) {
            pharmacyUsers = proxyUsersInfo.response.filter(userAccess => userAccess.proxySource && userAccess.proxySource.toLowerCase() === 'rx' && userAccess.status.toLowerCase() === 'approved');
            pharmacyPendingUsers = proxyUsersInfo.response.filter(userAccess => userAccess.proxySource && userAccess.proxySource.toLowerCase() === 'rx' && userAccess.status.toLowerCase() === 'pending');
            myChartPendingUsers = proxyUsersInfo.response.filter(userAccess => userAccess.proxySource && userAccess.proxySource.toLowerCase() === 'epic' && userAccess.status.toLowerCase() === 'pending');
        }

        const hasMChartUsers = myChartUsers && myChartUsers.length > 0;
        const hasMyChartPendingUsers = myChartPendingUsers && myChartPendingUsers.length > 0;
        const hasPharmacyUsers = pharmacyUsers && pharmacyUsers.length > 0;
        const hasPharmacyPendingUsers = pharmacyPendingUsers && pharmacyPendingUsers.length > 0;

        const hasAtleastOneFamilyMember = hasMChartUsers || hasMyChartPendingUsers || hasPharmacyUsers || hasPharmacyPendingUsers;
        const totalCount = proxyUsersInfo && proxyUsersInfo.response && proxyUsersInfo.response.length;
        const hasFamilyMembers = hasAtleastOneFamilyMember ? true : false;
        const subHeading = totalCount > 1 ? <>There are {numIntoWords(totalCount)} family members already connected to this account</> : <>There is one family member already connected to this account</>;
        const btnprops = (<div className="row text-center family-members__footer">
            <div className="col-12 add-family-btn">
                <Link to={{ pathname: '/onboarding/proxyrequestDOB' }}
                    className="btn btn-primary"
                    onClick={() => this.UpdatePreference('AddFamilyMember',hasFamilyMembers)}>
                    ADD FAMILY MEMBERS
                </Link>
            </div>
            <div className="col-12 skip-family-btn">
                <Link to={{ pathname: '/onboarding/managenotifications' }}
                    className="btn text-btn"
                    onClick={() => { this.UpdatePreference('Skip', hasFamilyMembers); this.goToNextPage() }}>
                    SKIP ADDING FAMILY MEMBERS
                </Link>
            </div>
        </div>);

        return (
            <>
                {(typeof hasProxySuggestions === 'undefined' || typeof proxyUsersInfo === 'undefined' || proxyUsersInfo.waiting)
                    ?
                    <>
                        <div className="row overlay-loading-container">
                            <div className="col-12 align-self-center">
                                <Spinner />
                            </div>
                        </div>
                    </>

                    :
                    hasProxySuggestions && EnableProxySuggestion
                        ?
                        < ProxySuggestions />
                        :
                        
                            !hasAtleastOneFamilyMember ?
                                <FamilyWithNoMember btnprops={btnprops} />
                                :
                            <>
                            <div className="container-fluid family-members-container">
                                    <div className="row">
                                        <div className="col-12 maxWidth-content">
                                            <h1 className="onboarding-layout__page-heading">Review Family Accounts</h1>
                                        </div>
                                        <div className="col-12 maxWidth-content">
                                            <div className="row family-members__body">
                                                <div className="col-12">
                                                    <div className="row">
                                                        <div className="col-12" >
                                                            <p className="family-member__subheading">{subHeading}</p>
                                                        </div>
                                                    </div>

                                                    {/* Separate pharmacy and medical account display */}
                                                    {myChartUsers && myChartUsers.map((user, index) =>
                                                        <FamilyMemberProxyUser
                                                            displayName={user.displayName}
                                                            key={index}
                                                            type="Medical"
                                                        />
                                                    )}
                                                    {pharmacyUsers && pharmacyUsers.map((user, index) =>
                                                        <FamilyMemberProxyUser
                                                            displayName={user.displayName}
                                                            key={index}
                                                            type="Pharmacy"
                                                        />
                                                    )}

                                                    {/*PENDING USERS*/}
                                                    {myChartPendingUsers && myChartPendingUsers.map((user, index) =>
                                                        <FamilyMemberProxyUser
                                                            displayName={user.displayName}
                                                            isPending
                                                            key={index}
                                                            type="Medical"
                                                        />
                                                    )}
                                                    {pharmacyPendingUsers && pharmacyPendingUsers.map((user, index) =>
                                                        <FamilyMemberProxyUser
                                                            displayName={user.displayName}
                                                            isPending
                                                            key={index}
                                                            type="Pharmacy"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {btnprops}
                                        </div>
                                    </div>
                                </div> 
                                </>

                }                                              

            </>
        );
    }
}

const mapStateToProps = (state) => {
    let pl = [];

    if (state.domain.pl) {
        state.domain.pl.forEach((c, index, arr) => {
            pl.push(d.hydrateProxyUser(c));
        });

    }

    if (pl.length > 0) {
        pl.shift(); // remove the logged-in user from the list
    }

    let proxySource = 'Rx';
    if (state.domain.hm) {
        proxySource = "Rx,Epic";
    }
    /*else if (state.domain.hm) {
        proxySource = "Epic";
    }
    else if (state.domain.hp) {
        proxySource = "Rx";
    }*/
    let userAge = state.domain.cu?.ay || state.domain.age;

    return {
        proxyUsersInfo: state.common[types.REQUEST_PROXY_FAMILY_MEMBERS_LIST],
        myChartUsers: pl,
        hasMyChartLogin: state.domain.hm,
        isAdult: userAge && userAge > 18 ? true : false,
        history: state.session.history,
        showFamilyMembersScreen: state.session.showFamilyMembersScreen,
        showNotificationsScreen: state.session.showNotificationsScreen,
        proxySource: proxySource,
        useOnboardingLayout: state.session.useOnboardingLayout,
        hasProxySuggestions: state.session.hasProxySuggestions,
        newProxySuggestionList: state.session.newProxySuggestionList,
        EnableProxySuggestion: state.session.serverData && state.session.serverData.EnableProxySuggestion ? true : false,
    };
};

const mapDispatchToProps = (dispatch) => {

    return {
        getRequestProxyPendingUsers: (proxySource, userId) => dispatch({ type: types.REQUEST_PROXY_FAMILY_MEMBERS_LIST, data: { userId, proxySource } }),
        updateFamilyMembersScreenPreference: () => dispatch({ type: types.UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE }),
        getRequestProxySuggestion: () => dispatch({ type: types.REQUEST_PROXY_SUGGESTION_LIST })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FamilyMembers);